module.exports = __webpack_public_path__ + "static/media/white_twitter.89f279f5.svg";